import { ButtonIconPlainPermissioned } from "pages/gdt/plain/ButtonIconPlain";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { DATA_TABLE_TOOLTIP_ID } from "../DataTableTooltip";

interface QuickActionCancelTaskProps {
  tableId: string;
  rowId: string;
  readOnly?: boolean;
}

export const QuickActionCancelTask = ({
  tableId,
  rowId,
  readOnly,
}: QuickActionCancelTaskProps) => {
  const cancelTask = useDataTableContext((s) => s.cancelTask);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const { error } = await cancelTask({ tableId, rowId });
    setIsLoading(false);

    if (error === undefined) {
      addUtilityToastSuccess("Task canceled");
    } else {
      addUtilityToastFailure("Failed to cancel task");
    }
  };

  return (
    <ButtonIconPlainPermissioned
      requiredPermission="execute"
      aria-label="Cancel task"
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-content="Cancel task"
      iconSize="m"
      iconType="cross"
      color="warning"
      onClick={() => void handleClick()}
      isLoading={isLoading}
      disabled={readOnly}
      id={"quickActionCancelTask"}
    />
  );
};
